<template>
  <div class="customer-information section-box">
    <el-tabs type="border-card" v-model="tabId" @tab-click="handleClick">
      <el-tab-pane name="id_1" label="客户信息" lazy>
				<customer-info ref="customerInfo" v-show="!isCustomerEdit" @onChange="changeCustomerState"></customer-info>
				<customer-info-edit ref="customerInfoEdit" v-show="isCustomerEdit" @onChange="changeCustomerState"></customer-info-edit>
			</el-tab-pane>
      <el-tab-pane name="id_2" label="商务信息" lazy>
				<business-info ref="businessInfo"></business-info>
			</el-tab-pane>
      <el-tab-pane name="id_3" label="大客户信息" lazy>
        <big-customer-info ref="bigCustomerInfo"></big-customer-info>
      </el-tab-pane>
      <el-tab-pane name="id_4" label="工单信息" lazy>
        <order-info ref="orderInfo"></order-info>
      </el-tab-pane>
      <el-tab-pane name="id_5" label="联系人" lazy>
        <contact ref="contact"></contact>
      </el-tab-pane>
      <el-tab-pane name="id_6" label="商机" lazy>
        <opportunity ref="opportunity"></opportunity>
      </el-tab-pane>
      <el-tab-pane name="id_7" label="合同" lazy>
        <contract ref="contract"></contract>
      </el-tab-pane>
      <el-tab-pane name="id_8" label="跟进记录" lazy>
        <record ref="record"></record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import CustomerInfo from './index/customerInfo.vue'
import CustomerInfoEdit from './index/customerInfoEdit.vue'
import BusinessInfo from './index/businessInfo.vue'
import BigCustomerInfo from './index/bigCustomerInfo.vue'
import OrderInfo from './index/orderInfo.vue'
import Contact from './index/contact.vue'
import Opportunity from './index/opportunity.vue'
import Contract from './index/contract.vue'
import Record from './index/record.vue'
export default {
	components:{
		CustomerInfo,
    CustomerInfoEdit,
		BusinessInfo,
    BigCustomerInfo,
    OrderInfo,
    Contact,
    Opportunity,
    Contract,
    Record
	},
  data() {
    return {
      isCustomerEdit:false,
      tabId:'id_1'
		};
  },
  beforeRouteEnter (to, from, next){
    next(vm=>{
      //每次进入都显示客户信息页面
      vm.tabId='id_1';
      vm.isCustomerEdit=false;
      vm.$refs.customerInfo.pageInit();
    })
  },
  methods: {
    changeCustomerState(data){
      this.isCustomerEdit=data;
      if(data){
        this.$refs.customerInfoEdit.pageInit();
      }else{
        this.$refs.customerInfo.pageInit();
      }
    },
    handleClick() {
     switch(this.tabId){
        case 'id_1':
          this.isCustomerEdit=false;
          this.$refs.customerInfo.pageInit();
          break;
        case 'id_2':
          this.$nextTick(()=> {
            this.$refs.businessInfo.loadData();
          })
          break;
        case 'id_3':
          this.$nextTick(()=> {
            this.$refs.bigCustomerInfo.loadData();
          })
          break;
        case 'id_4':
          this.$nextTick(()=> {
            this.$refs.orderInfo.getEveryData();
          })
          break;
        case 'id_5':
          this.$nextTick(()=> {
            this.$refs.contact.loadList();
          })
          break;
        case 'id_6':
          this.$nextTick(()=> {
            this.$refs.opportunity.loadList();
          })
          break;
        case 'id_7':
          this.$nextTick(()=> {
            this.$refs.contract.loadList();
          })
          break;
        default:
          this.$nextTick(()=> {
            this.$refs.record.loadData();
          })
          break;
      }
    }
  },
};
</script>
<style lang="scss">
// .customer-information{
  
// }
</style>